import { ExternalLink } from 'lucide-react';
import React from 'react';

import { Badge, Link as DSLink, Text } from '@/design-system/components/ui';

interface Props {
  label: string;
  value: React.ReactNode;
  href: string;
}

export const TriggerExternalLinkDetail = ({ label, value, href }: Props) => {
  return (
    <div className="tw:flex tw:flex-col">
      <Text variant="body-sm" weight="bold" className="tw:mb-1">
        {label}
      </Text>
      <DSLink href={href} target="_blank" rel="noopener noreferrer" className="tw:no-underline">
        <Badge size="sm">
          <div className="tw:flex tw:flex-row tw:gap-1 tw:items-center">
            <span>{value}</span>
            <ExternalLink size={12} aria-hidden="true" />
          </div>
        </Badge>
      </DSLink>
    </div>
  );
};
